export default __webpack_public_path__ + "static/media/KillerSprint.b98dee3e.jpg";